<template>
  <div class="modal fade forgot_pass" id="forgot_pass_popup" tabindex="-1" role="dialog"
       aria-labelledby="" aria-hidden="true" data-backdrop="static"
       data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered" role="document">

      <!-- Step 1: Enter MSISDN -->
      <div class="modal-content step1_forgot" :class="step === 1 ? '': 'd-none'">
        <button type="button" class="close" @click="closeModal()" data-dismiss="modal" aria-label="Close">
          <img src="static/img/millen_images/popup-close.svg">
        </button>
        <div class="modal-header">
          <h5 class="modal-title">Wachtwoord vergeten?</h5>
          <h4>
            Vul hier je mobiele nummer in om je wachtwoord opnieuw in te stellen
          </h4>
        </div>
        <div class="modal-body">
          <form>
            <div :class="{'form-group': true, 'error': !isValidMsisdn}">
              <input type="tel" class="form-control" id="mobile"
                     name="mobile" placeholder="Je mobiele nummer"
                     v-model="msisdn" required/>
              <label v-if="!isValidMsisdn" class="form-control-label" for="mobile"/>
              <div v-if="!isValidMsisdn" class="error_msg">Ongeldig mobiele nummer.
                Je mobiele nummer moet beginnen met 06 en bestaat uit 10 cijfers.
                Of beginnend met 097 en bestaand uit 12 cijfers.
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <div v-if="internalError" class="error_msg">Oeps, er ging iets fout. Probeer het later nog eens.
          </div>
          <button type="button" class="black_btn step1" @click.prevent="proceedToStep2">Verder</button>
          <div class="dots-container">
            <div class="dot step1 active"></div>
            <div class="dot step2"></div>
            <div class="dot step3"></div>
          </div>
        </div>
      </div>

      <!-- Step 2: PIN Verification -->
      <div class="modal-content step2_forgot" :class="step === 2 ? '': 'd-none'">
        <button type="button" class="close" @click="closeModal()" data-dismiss="modal" aria-label="Close">
          <img src="static/img/millen_images/popup-close.svg">
        </button>
        <div class="modal-header">
          <h5 class="modal-title">Verificatie van je mobiele nummer</h5>
          <h4>
            We hebben je een pincode gestuurd naar het volgende mobiele nummer: {{this.msisdn}}<br> Vul de ontvangen
            pincode in
          </h4>
        </div>
        <div class="modal-body">
          <form class="verification">
            <div class="d-flex justify-content-center">
              <input type="text" id="input1" ref="input1" maxlength="1" class="form-control" v-model="pin1"
                     @keyup.exact="gotoInput(2)" @keyup.exact.backspace="backToInput(1)" @focus="selectInput(1)">
              <input type="text" ref="input2" maxlength="1" class="form-control" v-model="pin2"
                     @keyup.exact="gotoInput(3)" @keyup.exact.backspace="backToInput(1)" @focus="selectInput(2)">
              <input type="text" ref="input3" maxlength="1" class="form-control" v-model="pin3"
                     @keyup.exact="gotoInput(4)" @keyup.exact.backspace="backToInput(2)" @focus="selectInput(3)">
              <input type="text" ref="input4" maxlength="1" class="form-control" v-model="pin4"
                     @keyup.exact="gotoInput(5)" @keyup.exact.backspace="backToInput(3)" @focus="selectInput(4)">
              <input type="text" ref="input5" maxlength="1" class="form-control" v-model="pin5"
                     @keyup.exact.backspace="backToInput(4)" @focus="selectInput(5)">
            </div>
            <div v-if="!isValidPin" class="error_msg">Pincode onjuist</div>
            <div v-if="internalError" class="error_msg">Oeps, er ging iets fout. Probeer het later nog
              eens.
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" @click.prevent="proceedToStep3" class="black_btn step2">Bevestigen</button>
          <div class="dots-container">
            <div class="dot step1"></div>
            <div class="dot step2 active"></div>
            <div class="dot step3"></div>
          </div>
        </div>
      </div>

      <!-- Step 3: Set New Password -->
      <div class="modal-content step3_forgot" :class="step === 3 ? '': 'd-none'">
        <button type="button" class="close" @click="closeModal()" data-dismiss="modal" aria-label="Close">
          <img src="static/img/millen_images/popup-close.svg">
        </button>
        <div class="modal-header">
          <h5 class="modal-title">Nieuw wachtwoord instellen</h5>
        </div>
        <div class="modal-body">
          <form>
            <div :class="{'form-group': true, 'error': !isValidPassword}">
              <input type="password" class="form-control" id="password"
                     name="password" placeholder="Wachtwoord" required
                     v-model="password"/>
              <label v-if="!isValidPassword" class="form-control-label" for="password"/>
              <div v-if="!isValidPassword" class="error_msg">Wachtwoord bevat minder dan 8 tekens.</div>
            </div>
            <div :class="{'form-group': true, 'error': !isValidConfirmPassword}">
              <input type="password" class="form-control" id="pass"
                     name="pass" placeholder="Herhaal wachtwoord" required
                     v-model="confirmPassword"/>
              <label v-if="!isValidConfirmPassword" class="form-control-label" for="pass"/>
              <div v-if="!isValidConfirmPassword" class="error_msg">Wachtwoorden komen niet overeen</div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <div v-if="internalError" class="error_msg">Oeps, er ging iets fout. Probeer het later nog eens.
          </div>
          <button type="button" @click.prevent="createNewPassword" class="black_btn step3">Bevestigen</button>
          <div class="dots-container">
            <div class="dot step1"></div>
            <div class="dot step2"></div>
            <div class="dot step3 active"></div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import router from "../../router";
import gtm_analytics from "../../common/mixin/gtm_analytics";

export default {
  name: "ForgotPassword",
  mixins: [
    gtm_analytics
  ],
  data() {
    return {
      msisdn: null,
      isValidMsisdn: true,
      step: 1,
      pin1: "",
      pin2: "",
      pin3: "",
      pin4: "",
      pin5: "",
      isValidPin: true,
      password: null,
      confirmPassword: null,
      isValidPassword: true,
      isValidConfirmPassword: true,
      internalError: false
    }
  },

  mounted() {
    $('#forgot_pass_popup').modal('show')
    this.pushPopUp('Popup visit', 'Forgot Password Pop Up')
  },

  computed: {
    ...mapGetters([
      'getLoginResponse',
      'isForgotPasswordModalOpen',
      'getPinResponse',
      'getAuthenticatePinResponse',
      'getHasPasswordResponse',
      'getCreatePasswordResponse'
    ]),

    pins() {
      return this.pin1 + this.pin2 + this.pin3 + this.pin4 + this.pin5;
    }
  },

  methods: {
    ...mapMutations([
      'updateForgotPasswordModal',
      'updateMsisdn',
      'updatePinResponse',
      'updateAuthenticatePinResponse',
      'updateLoginModal',
      'updatePassword',
      'updateAccessToken',
      'updateRegisterModal'
    ]),

    ...mapActions([
      'accountLogin',
      'generatePin',
      'authenticatePin',
      'hasPassword',
      'createPassword',
      'updateMarketingConsent'
    ]),

    closeModal() {
      $('#forgot_pass_popup').modal('hide')
      this.updateForgotPasswordModal(false)
      this.$store.commit('storeRegisterMarketingConsentTemp', null)
    },

    msisdnValidation() {
      return (/^(06[0-9]{8}|097[0-9]{9})$/.test(this.msisdn))
    },

    passwordValidation() {
      return (/^.{8,}$/.test(this.password))
    },

    resetValidityFlags() {
      this.isValidPassword = true
      this.isValidConfirmPassword = true
      this.isValidPin = true
      this.internalError = false
    },

    comparePasswords() {
      return this.password === this.confirmPassword
    },

    gotoInput(num) {
      const input = this.$refs["input" + num];
      input.select();
      input.focus();
    },

    selectInput(num) {
      this.$refs["input" + num].select();
    },

    backToInput(num) {
      this["pin" + num + 1] = "";
      this.gotoInput(num);
    },

    // Step 1: Validate MSISDN and check password existence
    proceedToStep2() {
      this.resetValidityFlags()
      // store user's inputs
      this.isValidMsisdn = this.msisdnValidation()
      if (this.isValidMsisdn) {
        this.updateMsisdn(this.msisdn)
        this.updatePinResponse(null)
        const payload = { msisdn: this.msisdn }

        // Check if user has already password
        this.hasPassword(payload)
          .then(() => {
            if (this.getHasPasswordResponse !== null) {
              this.handlePasswordResponse()
            } else {
              this.internalError = true
            }
          })
      }
    },

    // Handle password existence check response
    handlePasswordResponse() {
      if (this.getHasPasswordResponse.hasPassword !== null) {
        if (!this.getHasPasswordResponse.hasPassword) {
          // User's msisdn exists but does not have password
          this.goToRegister()
        } else {
          // User's msisdn exists and has password
          this.generatePinCode()
        }
      } else {
        // msisdn does not exist in the db.
        if (this.getHasPasswordResponse.failReason === "NOT_EXISTS")
          this.isValidMsisdn = false
        else
          this.internalError = true
      }
    },

    // Generate PIN for password reset
    generatePinCode() {
      this.generatePin({ msisdn: this.msisdn, forgotPassword: true })
        .then(() => {
          if (this.getPinResponse !== null && this.getPinResponse.result === "SUCCESS") {
            this.step = 2;
          } else {
            this.internalError = true
          }
        })
    },

    // Redirect to register popup if user has no password
    goToRegister() {
      $('#forgot_pass_popup').modal('hide')
      this.updateForgotPasswordModal(false)
      this.updateRegisterModal(true)
    },

    // Step 2: Verify PIN
    proceedToStep3() {
      this.resetValidityFlags()
      if (this.pins.length === 5) {
        const payload = {
          msisdn: this.msisdn,
          inputPin: this.pins,
        };
        this.authenticatePin(payload)
          .then(() => {
            if (this.getAuthenticatePinResponse.result === "SUCCESS") {
              this.step = 3;
            } else if (this.getAuthenticatePinResponse.failReason === "WRONG_PIN") {
              this.isValidPin = false
            } else {
              this.internalError = true
            }
          })
      } else {
        this.isValidPin = false
      }
    },

    // Step 3: Create new password
    createNewPassword() {
      // validate Password
      this.resetValidityFlags()
      if (!this.passwordValidation()) {
        this.isValidPassword = false
      } else {
        this.isValidPassword = true
        // compare password and confirmPassword
        if (!this.comparePasswords()) {
          this.isValidConfirmPassword = false
        } else {
          this.isValidConfirmPassword = true
          const payload = { msisdn: this.msisdn, password: this.password }
          this.createPassword(payload)
            .then(() => {
              this.handleCreatePasswordResponse()
            })
        }
      }
    },

    // Handle password creation response
    handleCreatePasswordResponse() {
      if (this.getCreatePasswordResponse.result === "SUCCESS") {
        this.submitLogin()
      } else {
        this.internalError = true
      }
    },

    // Final step: Auto-login with new password + handle marketing consent
    submitLogin() {
      this.updateMsisdn(this.msisdn)
      this.updatePassword(this.password)
      this.accountLogin()
        .then(() => {
          if (this.getLoginResponse.isUserLoggedIn === true) {
            this.handleMarketingConsentFromRegistration()
            this.updateAccessToken(this.getLoginResponse.encryptedKey)
            this.updateForgotPasswordModal(false)
            $('#forgot_pass_popup').modal('hide')
            router.push({ name: 'Account' })
          } else {
            if (this.getLoginResponse.failReason === 'WRONG_PASSWORD') {
              this.isValidPassword = false
            } else if (this.getLoginResponse.failReason === 'NOT_REGISTERED') {
              this.isValidMsisdn = false
            } else {
              this.internalError = true
            }
          }
        })
    },

    // Handle marketing consent for users coming from registration
    handleMarketingConsentFromRegistration() {
      if (this.$store.state.registerMarketingConsentTemp &&
        this.$store.state.registerMarketingConsentTemp.msisdn === this.msisdn) {
        this.updateMarketingConsent({
          msisdn: this.msisdn
        })
          .catch((error) => {
            console.error('Error updating marketing consent from registration:', error)
          })
      }
      this.$store.commit('storeRegisterMarketingConsentTemp', null)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/ForgotPassword.vue